import { Accordion, Button, Form, Stack } from "react-bootstrap";
import { generateOptionsArray } from "@/functions/generateOptionsArray";
import { useState } from "react";
import classes from "./styles.module.scss";
import clsx from "classnames";

export const FAQs = ({ className, items, questionKey = "question", answerKey = "answer" }) => {
  const [tags] = useState(generateOptionsArray(items, "tags"));
  const [activeTag, setActiveTag] = useState("");
  const [query, setQuery] = useState("");

  return (
    <div className={clsx(className, classes.faqs)}>
      {tags && (
        <Stack className="flex-md-row mb-4" gap={{ xs: 2, md: 4 }}>
          {tags.map((tag) => (
            <Button
              onClick={(e) => {
                setActiveTag(activeTag === tag ? "" : tag);
                e.currentTarget.blur();
              }}
              className={clsx("flex-grow-1", { active: tag === activeTag })}
              variant="outline-blue"
              key={tag}
              dangerouslySetInnerHTML={{ __html: tag }}
            />
          ))}
        </Stack>
      )}
      <Form.Control
        value={query}
        className="mb-4"
        placeholder="Have a question you'd like answering? Search our frequently asked questions..."
        onChange={(e) => setQuery(e.target.value)}
      />
      <Accordion>
        {items
          .filter((i) => i.tags.toLowerCase().includes(activeTag.toLowerCase()))
          .filter((i) => i.question.toLowerCase().includes(query.toLowerCase()))
          .map((i) => (
            <Accordion.Item key={i.id} eventKey={i.id}>
              <Accordion.Button>
                <span dangerouslySetInnerHTML={{ __html: i[questionKey] }} />
              </Accordion.Button>
              <Accordion.Body dangerouslySetInnerHTML={{ __html: i[answerKey] }} />
            </Accordion.Item>
          ))}
      </Accordion>
    </div>
  );
};

export default FAQs;
